<template>
  <div :class="['filters-container', { 'no-shadow': disableShadow }]">
    <div class="filters-row">
      <div class="primary-controls">
        <SearchInput ref="searchInputRef" @search-update="onSearch" />
        <ColumnDropDown v-if="!disableColumnDropdown" ref="columnDropDownRef" :ignored-keys="ignoredKeys" @on-column-change="onColumnChange" />
        <Filters ref="filtersRef" :raw-filter-config="rawFilterConfig" @on-filter-change="onFilterChange"/>
      </div>
      <div class="secondary-controls">
        <ButtonSpinner 
          title="Reset"
          @click="handleReset()" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';

import SearchInput from './SearchInput.vue';
import ColumnDropDown from './ColumnDropDown.vue';
import Filters from './Filters.vue';
import ButtonSpinner from '../../ButtonSpinner.vue';

const filtersRef = ref(null)
const columnDropDownRef = ref(null)
const searchInputRef = ref(null)

const props = defineProps({
  rawFilterConfig: {
    type: Object,
    required: true
  },
  ignoredKeys: {
    type: Set,
    required: true
  },
  disableShadow: {
    type: Boolean,
    default: false
  },
  disableColumnDropdown: {
    type: Boolean,
    default: false
  }
})


const emit = defineEmits(['search-change', 'filters-change', 'columns-change'])

const onSearch = (newSearchQuery) => {
  emit('search-change', newSearchQuery)
}

const onColumnChange = (newColumnData) => {
  emit('columns-change', newColumnData)
}

const onFilterChange = (newFilterData) => {
  emit('filters-change', newFilterData)
}
function handleReset() {
  if(!props.disableColumnDropdown) {
    columnDropDownRef.value.reset();
  }
  filtersRef.value.reset();
  searchInputRef.value.reset();
}

async function Initialize(data) {
  if(!props.disableColumnDropdown) {
    columnDropDownRef.value.setColumnOptions(data[0])
  }
  filtersRef.value.setFilterOptions(data)
  handleReset()
}

defineExpose({
  Initialize
})

</script>

<style scoped>
.filters-container {
  padding: 20px;
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(20px);
  border-radius: var(--border-radius-card);
  border: 1px solid rgba(0, 0, 0, 0.05);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  margin-bottom: 7px;
  z-index: 10;
  position: relative;
}

.filters-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  flex-wrap: wrap;
}

.no-shadow {
  box-shadow: none !important;
  backdrop-filter: none !important;
  border: none !important;
  background: white !important;
}


.primary-controls {
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1;
}

.secondary-controls {
  display: flex;
  align-items: center;
}
</style>